module.exports = "<h4>{{ title }}</h4>\r\n<p>{{ message }}</p>\r\n<button type=\"button\" class=\"btn btn-primary pull-right\" \r\n    (click)=\"dialogRef.close(false)\">Peruuta</button>\r\n<button type=\"button\" class=\"btn btn-danger\"  \r\n    (click)=\"dialogRef.close(true)\">Poista</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/confirm-dialog/confirm-dialog.component.html
// module id = ./src/app/confirm-dialog/confirm-dialog.component.html
// module chunks = main